var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',[_c('router-view',{attrs:{"name":"sidebar"}})],1),_c('v-main',{staticClass:"content"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }